"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.normalizeDocumentNode = exports.onlyUniqueFragments = exports.notFragments = exports.isFragmentDefinition = void 0;
const filter_1 = __importDefault(require("lodash/fp/filter"));
const pipe_1 = __importDefault(require("lodash/fp/pipe"));
const uniqBy_1 = __importDefault(require("lodash/fp/uniqBy"));
function isFragmentDefinition(def) {
    return def.kind === 'FragmentDefinition';
}
exports.isFragmentDefinition = isFragmentDefinition;
exports.notFragments = (0, filter_1.default)(def => def.kind !== 'FragmentDefinition');
exports.onlyUniqueFragments = (0, pipe_1.default)((0, filter_1.default)(isFragmentDefinition), (0, uniqBy_1.default)(def => def.name));
// Fixing issue https://github.com/dotansimha/graphql-code-generator/issues/6239
// @todo Remove when it's fixed in library
function normalizeDocumentNode(doc) {
    if ('__normalized' in doc)
        return doc;
    return Object.assign(doc, {
        __normalized: true,
        definitions: [
            ...(0, exports.notFragments)(doc.definitions),
            ...(0, exports.onlyUniqueFragments)(doc.definitions),
        ],
    });
}
exports.normalizeDocumentNode = normalizeDocumentNode;
//# sourceMappingURL=graphql.utils.js.map